import React from 'react';
import { Helmet } from 'react-helmet-async';
import CustomLink from '../components/CustomLink';
import T from '../components/T';

// Shown for unknown routes and unknown article ids.
const NotFound: React.FC = () => (
  <div className="bg-[var(--color-bg-primary)] py-[8rem] min-h-screen transition-colors duration-300" style={{fontFamily: 'Short Stack, cursive'}}>
    <Helmet>
      <title>404 — Pieter Floris Jacobs</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div className="container mx-auto px-6 max-w-6xl text-center">
      <h1 className="text-3xl md:text-4xl mb-6 mt-8 text-[var(--color-text-primary)] font-normal" style={{fontFamily: 'Indie Flower, cursive'}}>
        <T k="notFound.title" />
      </h1>
      <p className="text-base lg:text-lg text-[var(--color-text-secondary)] mb-8">
        <T k="notFound.text" />
      </p>
      <CustomLink to="/"><T k="notFound.home" /></CustomLink>
    </div>
  </div>
);

export default NotFound;
